import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import {
  tap,
  map,
  switchMap,
  take,
  catchError,
  withLatestFrom,
  filter,
  concatMap,
  mergeMap,
} from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-visualizar-usuario.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { UserService } from '@services-api/user.service';
import { FecharAction } from '../actions/master-fechar-visualizar-usuario.action';
import { environment } from '@env/environment';
import { CryptoService } from '@app/core/services/crypto/crypto.service';
const BASE_PATH = environment.basePath;
@Injectable()
export class MasterVisualizarUsuarioEffects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
    private service: UserService,
    private fecharAction: FecharAction,
    private cryptoService: CryptoService,
  ) { }

  initValue$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromMaster.initValueAction),
        switchMap(payload => {
          const code = payload.code;
          if (payload.parentCtx && payload.parentCtx.roleName) {
            return this.store
              .select(fromStore.selectRoleValue, {
                ...payload.parentCtx,
                code,
              })
              .pipe(
                map(result =>
                  fromMaster.initValueSuccessAction({
                    ...payload,
                    result,
                  }),
                ),
                catchError(error =>
                  of(fromMaster.initValueFailAction({ ...payload, error })),
                ),
              );
          } else {
            let encrypted = this.cryptoService.encrypt(`{"id":"123"}`);

            console.log(encrypted, ' encrypted~~~~~~');
            return this.httpClient
              .post<any>(`${BASE_PATH}/bff/users/view/`, {
                encryptedObject: encrypted,
              })
              .pipe(
                map(result =>
                  fromMaster.initValueSuccessAction({
                    ...payload,

                    result,
                  }),
                ),
                catchError(error =>
                  of(fromMaster.initValueFailAction({ ...payload, error })),
                ),
              );
          }
        }),
      ),

  );

  fecharAction$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.fecharAction),
      switchMap(payload => {
        return this.actionHandler.perform(this.fecharAction, payload).pipe(
          map(result =>
            fromMaster.fecharSuccessAction({ ...payload, data: result }),
          ),
          catchError(error => of(fromMaster.fecharFailAction({ ...payload }))),
        );
      }),
    ),
  );
}
